import BtnCreateLicenseAndRedirect from './BtnCreateLicenseAndRedirect';

export default BtnCreateLicenseAndRedirect;
